import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
    headlineFontFamily,
    headlineFontWeight,
    headlineLetterSpacing,
    headlineLineHeight,
    headlineXxlFontSize,
    headlineXlFontSize,
    headlineLargeFontSize,
    headlineMediumFontSize,
    headlineSmallFontSize,
    headlineXsFontSize,
    bodyFontWeight,
} from 'common/styles/typography';

const HEADLINE_SIZES = {
    xxl: headlineXxlFontSize,
    xl: headlineXlFontSize,
    large: headlineLargeFontSize,
    medium: headlineMediumFontSize,
    small: headlineSmallFontSize,
    xs: headlineXsFontSize,
};

const HEADLINE_WEIGHTS = {
    headline: headlineFontWeight,
    body: bodyFontWeight,
};

const withHeadlineStyles = (StyledComponent) =>
    styled(StyledComponent)`
        font-family: ${headlineFontFamily};
        font-weight: ${(styledProps) => HEADLINE_WEIGHTS[styledProps.weight]};
        line-height: ${headlineLineHeight};
        letter-spacing: ${headlineLetterSpacing};
        font-size: ${(styledProps) => HEADLINE_SIZES[styledProps.size]};
    `;

// These are separated to avoid defining the components in the render
const headlineStyledComponents = {
    h1: withHeadlineStyles(styled.h1``),
    h2: withHeadlineStyles(styled.h2``),
    h3: withHeadlineStyles(styled.h3``),
    h4: withHeadlineStyles(styled.h4``),
    h5: withHeadlineStyles(styled.h5``),
    h6: withHeadlineStyles(styled.h6``),
};

export const Headline = ({ tag, size, weight, ...props }) => {
    const StyledComponent = headlineStyledComponents[tag];

    return <StyledComponent {...props} size={size} weight={weight} />;
};

Headline.propTypes = {
    tag: PropTypes.oneOf(Object.keys(headlineStyledComponents)),
    children: PropTypes.node,
    size: PropTypes.oneOf(Object.keys(HEADLINE_SIZES)),
    weight: PropTypes.oneOf(Object.keys(HEADLINE_WEIGHTS)),
};

Headline.defaultProps = {
    tag: 'h1',
    children: null,
    size: 'medium',
    weight: 'headline',
};
